<template>
  <div class="flex w-full flex-col">
    <div>
      <global-uploader-button :label="labelAction"></global-uploader-button>
    </div>
    <div class="w-full">
      <global-uploader-item @clickFile="clickFile"></global-uploader-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labelAction: {
      type: String,
      default: "Tambah File",
    },
  },
  methods: {
    clickFile(value) {
      this.$emit("clickFile", value);
    },
  },
};
</script>